import React from 'react';
import { notUndefined } from '../../../../lib/typeCheck';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';

const formatDustHead = (head: string) => {
  if (head === 'pm25') return 'PM2.5';
  return head.toUpperCase();
}

const formatLimitHeadCell = (limit, head: string) => {
  let cell = { final_level: '', exceedances: '' };
  if (limit['input_' + head]) {
    cell = {
      final_level: parseFloat(limit.last_value[head].value).toFixed(1) + ' µg/m³',
      exceedances: limit.last_value[head].exceeded? '1' : '0'
    }
  }
  return cell;
}

export const DustLimitTable = ({ limits }: { limits: any }) => {
  
  // Find which heads are used across all limits
  const heads = ['pm10', 'pm4', 'pm25', 'pm1', 'tsp'].filter(type => {
    return limits.filter(limit => notUndefined(limit['input_' + type]) && limit['input_' + type]).length > 0;
  })
  
  return (
    <Table>
      <Thead>
        <Row>
          <HeadingCell rowSpan='2'>Position</HeadingCell>
          <HeadingCell rowSpan='2'>Limit</HeadingCell>
          {heads.map(head => (
            <HeadingCell colSpan='2'>{formatDustHead(head)}</HeadingCell>
          ))}
        </Row>
      </Thead>
      <Tbody>
        <Row>
          {heads.map(head => (
            <React.Fragment>
              <Cell>Final Level</Cell>
              <Cell>Exceedances</Cell>
            </React.Fragment>
          ))}
        </Row>
        {limits.map((limit,index) => (
          <Row>
          <Cell>{index === 0? 'Primary Limit' : 'Limit ' + (index + 1)}</Cell>
          <Cell>{parseFloat(limit.threshold).toFixed(0)} µg/m³</Cell>
          {heads.map(head => (
            <React.Fragment>
              <Cell>{formatLimitHeadCell(limit, head).final_level}</Cell>
              <Cell centered={true}>{formatLimitHeadCell(limit, head).exceedances}</Cell>
            </React.Fragment>
          ))}
          </Row>
        ))}
      </Tbody>
    </Table>
  )
}